import { getCurrentAppState } from "../components/AlmeApp/AlmeAppState";
import { QualtricsCookies } from "../components/Common/constants";
import { getQualtricsCookieValue } from "./QualtricsCookiesUtils";
function IsQualtricsSurveyEnabled(almeAppConfig) {
    return almeAppConfig["Qualtrics.IsEnabled"];
}
function getQualtricsZoneId(almeAppConfig) {
    return almeAppConfig["Qualtrics.QZoneID"];
}
function getQualtricsInterceptID(appConfig, isLiveChat, isLoggedIn) {
    let interceptId = undefined;
    if (appConfig && appConfig["Qualtrics.Intercepts"] !== undefined) {
        const interseptsJSON = appConfig["Qualtrics.Intercepts"];
        const intercepts = JSON.parse(interseptsJSON);
        if (isLiveChat) {
            interceptId = isLoggedIn
                ? intercepts["PostLoginLiveChat"]
                : intercepts["PreLoginLiveChat"];
        }
        else {
            interceptId = isLoggedIn
                ? intercepts["PostLogin"]
                : intercepts["PreLogin"];
        }
    }
    return interceptId;
}
export function getLoginType(isLiveChat, isLoggedIn) {
    if (!isLiveChat) {
        return isLoggedIn ? "Post%20Login%20IVA" : "Pre%20Login%20IVA";
    }
    else {
        return isLoggedIn ? "Post%20Login%20Live%20Chat" : "Pre%20Login%20Live%20Chat";
    }
}
export function getInterceptName(isLiveChat, isLoggedIn) {
    if (!isLiveChat) {
        return isLoggedIn ? "Post%20Login%20Ext%20IVA%20Only" : "Pre%20Login%20Ext%20IVA%20Only";
    }
    else {
        return isLoggedIn ? "Post%20Login%20LIVE%20CHAT%20(after%20Ext%20IVA)" : "Pre%20Login%20LIVE%20CHAT%20(after%20Ext%20IVA)";
    }
}
export function fetchQualtrics(qZoneID) {
    void fetchQualtricsData(qZoneID);
}
export async function fetchQualtricsData(qZoneID) {
    const url = 'https://siteintercept.qualtrics.com/WRSiteInterceptEngine/Targeting.php?Q_ZoneID=' + qZoneID + '&Q_CLIENTVERSION=1.106.0&Q_CLIENTTYPE=web';
    try {
        if (qualtricsIntercept === undefined) {
            const response = await fetch(url);
            // eslint-disable-next-line  @typescript-eslint/no-unsafe-assignment
            const interceptInfo = await response.json();
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            qualtricsIntercept = interceptInfo.ClientSideIntercepts;
        }
    }
    catch (error) {
        console.log(error);
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getQualtricsSurveyData(qualtricsInterceptList, interceptId) {
    let filteredURL = '';
    if (qualtricsInterceptList !== undefined) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access        
        for (const value of qualtricsInterceptList) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access  
            if (value['InterceptID'] === interceptId) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access  
                filteredURL = value['ActionSets'][0]['Target']['OriginalURL'];
            }
        }
    }
    return filteredURL;
}
let qualtricsIntercept;
export function getQualtricsSurveyUrl(almeAppConfig, isLiveChat, isLoggedIn, chatId) {
    const qZoneID = getQualtricsZoneId(almeAppConfig);
    const interceptId = getQualtricsInterceptID(almeAppConfig, isLiveChat, isLoggedIn);
    const almeAppState = getCurrentAppState();
    let qualtricsSurveyURL = "";
    if (IsQualtricsSurveyEnabled(almeAppConfig) && qZoneID && interceptId && almeAppState.chatId) {
        fetchQualtrics(qZoneID);
        const qualtricsOriginalUrl = getQualtricsSurveyData(qualtricsIntercept, interceptId);
        if (qualtricsOriginalUrl !== undefined && qualtricsOriginalUrl !== "") {
            const ivaLaunchType = getQualtricsCookieValue(QualtricsCookies.IVALaunchType) || "";
            const loginType = getLoginType(isLiveChat, isLoggedIn);
            const interceptname = getInterceptName(isLiveChat, isLoggedIn);
            if (!isLiveChat) {
                qualtricsSurveyURL = qualtricsOriginalUrl + "&Launch_Type=" + ivaLaunchType + "&Session_ID=" + almeAppState.chatId + "&ExternalDataReference="
                    + almeAppState.chatId + "&Login_Type=" + loginType + "&Intercept=" + interceptname;
            }
            else if (isLiveChat && almeAppState.liveChatCaseID !== undefined) {
                qualtricsSurveyURL = qualtricsOriginalUrl + "&Launch_Type=" + ivaLaunchType + "&Session_ID=" + almeAppState.chatId + "&ExternalDataReference="
                    + almeAppState.chatId + "&Login_Type=" + loginType + "&Intercept=" + interceptname +
                    "&LiveChatCaseID=" + almeAppState.liveChatCaseID;
            }
        }
    }
    return qualtricsSurveyURL;
}
